import { Injectable } from "@angular/core";
import { FingerModel } from "../../authentication-rnec/finger.model";
import { FingerEnum } from "../../authentication-rnec/fingers.enum";
import { IFingerRandom } from "../models/IFingerRandom.model";
import { CustomLogger } from "@npm-bbta/bbog-sg-frontend-logs-lib";

const logger = new CustomLogger('FingerprintUtil', '#ff8c00');

@Injectable()
export class FingerprintUtil {

    initializeFingerToCapture(): IFingerRandom {
        const fingerLeftHand = this.getRandomFingerLeftHand();
        const fingerRightHand = this.getRandomFingerRightHand();
        logger.log('Finger Models:', fingerLeftHand, fingerRightHand);
        return {
            fingerLeftHand,
            fingerRightHand
        }
    }

    getRandomFingerLeftHand(): FingerModel {
        const posibleFingerIndexes = [ FingerEnum.LEFT_THUMB, FingerEnum.LEFT_INDEX, FingerEnum.LEFT_MIDDLE,
            FingerEnum.LEFT_RING, FingerEnum.LEFT_PINKY];

        const randomFingerNumber = this.getRandomFingerNumber(posibleFingerIndexes);
        return FingerEnum.get[randomFingerNumber];
    }

    getRandomFingerRightHand(): FingerModel {
        const posibleFingerIndexes = [FingerEnum.RIGHT_THUMB, FingerEnum.RIGHT_INDEX, FingerEnum.RIGHT_MIDDLE,
            FingerEnum.RIGHT_RING, FingerEnum.RIGHT_PINKY];

        const randomFingerNumber = this.getRandomFingerNumber(posibleFingerIndexes);
        return FingerEnum.get[randomFingerNumber];
    }

    getRandomFingerNumber(posibleFingerIndexes: number[]): number {
        const randomIndex = this.getRandomFingerIndex(posibleFingerIndexes);
        return posibleFingerIndexes[randomIndex];
    }

    getRandomFingerIndex(posibleFingerIndexes: number[]): number {
        return Math.floor(this.getRandomArbitrary(0, posibleFingerIndexes.length));
    }

    getRandomArbitrary(min: number, max: number): number {
        return Math.random() * (max - min) + min;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/util/FingerprintUtil.ts